import { ROSTER_MOVES_TRACKED_SINCE } from '../data/types';

/** Avertissement visible : libérations et LTIR n'ont pas d'historique avant leur date de suivi. */
export function RosterMovesNotice() {
  return (
    <p className="ci-notice" role="note">
      <strong>
        Important : les statistiques de libérations et de blessures (LTIR) ne sont comptées qu’à
        partir du {ROSTER_MOVES_TRACKED_SINCE}. Aucune donnée n’existe avant cette date.
      </strong>
    </p>
  );
}
